import { render, staticRenderFns } from "./customer-list.vue?vue&type=template&id=76a861e0&scoped=true&"
import script from "./customer-list.vue?vue&type=script&lang=js&"
export * from "./customer-list.vue?vue&type=script&lang=js&"
import style0 from "./customer-list.vue?vue&type=style&index=0&id=76a861e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a861e0",
  null
  
)

export default component.exports